import {
  PRODUCT_MENU_CLEAR_FILTER,
  PRODUCT_MENU_LOAD_FILTERS,
  PRODUCT_MENU_SET_COLOR,
  PRODUCT_MENU_SET_FILTER,
  PRODUCT_MENU_SET_SELECTABLE_COLORS,
  PRODUCT_MENU_SET_SUB_FILTER,
  PRODUCT_MENU_SET_SUB_FILTER_ITEMS,
  PRODUCT_MENU_SET_SUB_FILTER_OPTIONS,
} from '../actionConstants';
import { Filter, SubFilter } from './productMenuTypes';
import { Action } from '../../generalTypes';

export const setFilters = (
  filters: Filter[]
): Action<{ filters: Filter[] }> => ({
  type: PRODUCT_MENU_LOAD_FILTERS,
  payload: { filters },
});

export const actionSetSwiperSubFilter = (subFilter: SubFilter) => ({
  type: PRODUCT_MENU_SET_SUB_FILTER,
  payload: subFilter,
});

export const actionSetSwiperSubFilterItems = (subFilterItems: any) => ({
  type: PRODUCT_MENU_SET_SUB_FILTER_ITEMS,
  payload: subFilterItems,
});

export const actionSetColor = (color: string, filterName: string) => ({
  type: PRODUCT_MENU_SET_COLOR,
  payload: {
    filterName,
    color,
  },
});

export const actionSetFilter = (filter: string) => ({
  type: PRODUCT_MENU_SET_FILTER,
  payload: filter,
});

export const actionClearFilter = () => ({
  type: PRODUCT_MENU_CLEAR_FILTER,
});

export const actionSetSelectableColors = (
  selectableColors: any,
  filterName: string
) => ({
  type: PRODUCT_MENU_SET_SELECTABLE_COLORS,
  payload: {
    selectableColors,
    filterName,
  },
});

export const actionSetSubFilterOptions = (filter: string, options: any) => ({
  type: PRODUCT_MENU_SET_SUB_FILTER_OPTIONS,
  payload: {
    filter,
    options,
  },
});
